import { convertValueToString } from '@utils/function';
import { VariantAttribute } from '@ts/variant';
import { Dictionary } from '@ts/dictionary';
import { isInStock } from '@utils/stockStatus/isInStock';
import { getStockStatusDictionary } from '@utils/stockStatus/getStockStatusDictionary';
import { isSoonBackInStock } from '@utils/isSoonBackInStock';
import { getStockStatusText } from '@ngg/storefront-utils';

export const optionSorting = (
  [optionName1, variantAttribute1]: [string, VariantAttribute[]],
  [optionName2, variantAttribute2]: [string, VariantAttribute[]],
) => {
  const price =
    Math.min(...variantAttribute1.map((v) => v.price.price)) -
    Math.min(...variantAttribute2.map((v) => v.price.price));

  const stock =
    Number(...variantAttribute2.map((v) => v.stock)) -
    Number(...variantAttribute1.map((v) => v.stock));

  const text = convertValueToString(optionName1).localeCompare(
    convertValueToString(optionName2),
  );

  return stock || price || text;
};

export const optionSortingAlwaysCheapestFirst = (
  [optionName1, variantAttribute1]: [string, VariantAttribute[]],
  [optionName2, variantAttribute2]: [string, VariantAttribute[]],
) => {
  const price =
    Math.min(...variantAttribute1.map((v) => v.price.price)) -
    Math.min(...variantAttribute2.map((v) => v.price.price));

  const text = convertValueToString(optionName1).localeCompare(
    convertValueToString(optionName2),
  );

  return price || text;
};

export const itemIsInStock = (attrs: VariantAttribute[] | undefined) =>
  attrs && attrs.some((x) => isInStock(x.stockStatus));

const itemIsSoldOut = (attrs: VariantAttribute[] | undefined) =>
  attrs && attrs.every((attr) => attr.stockStatus === 'SoldOut');

export const hasSoonBackInStockStatus = (
  attrs: VariantAttribute[] | undefined,
) =>
  attrs &&
  attrs.some(({ stockStatus, nextDeliveryDate }) =>
    isSoonBackInStock(stockStatus, nextDeliveryDate),
  );

export const showStatus = (
  attrs: VariantAttribute[] | undefined,
  dictionary: Dictionary,
) => {
  if (!attrs?.length) return null;

  if (hasSoonBackInStockStatus(attrs)) {
    const { nextDeliveryDate, stockStatus } =
      attrs.find(({ stockStatus, nextDeliveryDate }) =>
        isSoonBackInStock(stockStatus, nextDeliveryDate),
      ) || {};

    return getStockStatusText({
      isShortened: true,
      stockStatus: stockStatus!,
      nextDeliveryDate: nextDeliveryDate,
      dictionary: getStockStatusDictionary(dictionary),
    });
  }

  if (itemIsInStock(attrs)) {
    return getStockStatusText({
      stockStatus: 'StockItem',
      dictionary: getStockStatusDictionary(dictionary),
    });
  }

  /** Hide delivery items for now
    if (attrs.every((attr) => attr.stockStatus === 'DeliveryItem')) {
        return getStockStatusText({ stockStatus: 'DeliveryItem', dictionary });
    } */

  if (itemIsSoldOut(attrs)) {
    return getStockStatusText({
      stockStatus: 'SoldOut',
      dictionary: getStockStatusDictionary(dictionary),
    });
  }

  return null;
};
